import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Paper, Snackbar } from "@mui/material";
import { Box } from "@mui/material";
import { TableContainer } from "@mui/material";
import LoadingVulpes from "../../../Styles/Loader/loading";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import EficienciaAlimentarViewTecnico from "../../../Styles/layout/eficienciaAlimentarView";
import { CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { Alert } from "../../../Components/Alert/Alert";
import { ICC_Caderno3, ICC_TipoAlimento_GH } from "../../../Interfaces/eficiencia_alimentar/cc_caderno_campo";
import { get } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { AuthContext } from "../../../AuthContext/AuthContext";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },

    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  })
);



export default function EFCadernoCampos() {
  const auth = useContext(AuthContext);
  const classes = useStyles();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const [obj_tabela, set_obj_tabela] = useState<ICC_Caderno3>();

  const [sub_tabela, set_sub_tabela] = useState<ICC_TipoAlimento_GH[]>([]);


  async function getTabela() {
    try {
      let res = await get(auth.token.cookie_token, `/get_tipo_alimento_id_rosto/${location.state.id_identificacao}`);

      if (res.status === 200) {
        set_obj_tabela(res.data.result);
      }

      let result = await get(auth.token.cookie_token, `/get_tipo_alimento_zona_homo_id_rosto/${location.state.id_identificacao}`);
      if (result.status === 200) {
        set_sub_tabela(result.data.result.sort((a: any, b: any) => {
          if (a.id_grupo > b.id_grupo) {
            return 1;
          }
          if (a.id_grupo < b.id_grupo) {
            return -1;
          }
          return 0;
        }));
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getTabela", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }


  useEffect(() => {
    (async () => {
      await getTabela();
    })();
  }, []);




  return (
    <div className={classes.root}>
      <EficienciaAlimentarViewTecnico title="CC Caderno de Campo" />
      <main className={classes.contents}>
        <div className={classes.toolbars} />

        <Box width="80%" margin="auto">
          <BeneficiarioNomeIdAlinhadoDireita />
        </Box>

        {isLoading ? (
          <LoadingVulpes />
        ) : (
          <CustomThemeProvider>
            <TableContainer
              component={Paper}
              variant="outlined"
              sx={{ height: "auto", width: "auto", padding: 2 }}
            >
              <Snackbar
                open={openSnackSuccess}
                autoHideDuration={2000}
                onClose={() => setOpenSnackSuccess(false)}
              >
                <Alert
                  onClose={() => setOpenSnackSuccess(false)}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  {message}
                </Alert>
              </Snackbar>
              <Snackbar
                open={openSnackError}
                autoHideDuration={2000}
                onClose={() => setOpenSnackError(false)}
              >
                <Alert
                  onClose={() => setOpenSnackError(false)}
                  severity="error"
                  sx={{ width: "100%" }}
                >
                  {message}
                </Alert>
              </Snackbar>

              <table style={{ width: "100%" }}>

                <div style={{
                  display: "flex",
                  flex: 1,

                }}>
                  <div style={{
                    display: 'flex',
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: "center",
                    border: `1px solid black`,
                    margin: 1,
                    fontSize: 12,
                    fontWeight: "bold",
                  }}>Efetivo Pecuário</div>

                  <div style={{
                    display: 'flex',
                    flex: 0.8,
                    alignItems: 'center',
                    flexDirection: 'column',
                    fontSize: 12,
                    fontWeight: "bold",

                  }}>
                    <div style={{
                      alignItems: "center",
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      border: `1px solid black`,
                      margin: 1,
                      width: '100%',
                      height: '100%'
                    }}>
                      <div>Tipo de alimento</div>
                      <div>(ton de Matéria-seca)</div>
                    </div>
                    <div style={{
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      display: 'flex',
                      flexDirection: 'row',
                      // backgroundColor:'red',
                      width: '100%',


                    }}>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "center",
                        justifyContent: "center",
                        margin: 1,
                        height: 40,


                        border: `1px solid black`,
                      }}>Pastagem</div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        margin: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        border: `1px solid black`,
                        height: 40,

                      }}>Silagem</div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        margin: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        border: `1px solid black`,
                        height: 40,

                      }}>Outra Forragem</div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        margin: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        border: `1px solid black`,
                        height: 40,

                      }}>Composto</div>
                    </div>


                  </div>

                </div>

                <div style={{
                  display: "flex",
                  flex: 1,

                }}>
                  <div style={{
                    display: 'flex',
                    flex: 0.2,
                    justifyContent: "center",
                    border: `1px solid black`,
                    margin: 1,
                    fontSize: 12,
                    flexDirection: 'column',
                    // fontWeight: "bold",,
                  }}>
                    <div style={{
                      padding: 1,
                      fontSize: 12,
                      fontWeight: "bold",

                    }}>
                      1. Plano de alimentação (necessidades anuais)

                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      Total de MS


                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      Peso na dieta (%)


                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    flex: 0.8,
                    alignItems: 'center',
                    flexDirection: 'column',
                    fontSize: 12,

                  }}>

                    <div style={{
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      display: 'flex',
                      flexDirection: 'row',
                      // backgroundColor:'red',
                      width: '100%',
                      height: '100%',


                    }}>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Pa_Total_MS_Pastagem === 0 ? 0 : obj_tabela?.Pa_Total_MS_Pastagem.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Pa_Peso_dieta_Pastagem === 0 ? 0 : obj_tabela?.Pa_Peso_dieta_Pastagem.toFixed(0).toString().replace('.', ',')}

                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Pa_Total_MS_Silagem === 0 ? 0 : obj_tabela?.Pa_Total_MS_Silagem.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Pa_Peso_dieta_Silagem === 0 ? 0 : obj_tabela?.Pa_Peso_dieta_Silagem.toFixed(0).toString().replace('.', ',')}
                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Pa_Total_MS_Outra_Ferragem === 0 ? 0 : obj_tabela?.Pa_Total_MS_Outra_Ferragem.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Pa_Peso_dieta_Outra_Ferragem === 0 ? 0 : obj_tabela?.Pa_Peso_dieta_Outra_Ferragem.toFixed(0).toString().replace('.', ',')}
                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Pa_Total_MS_Composto === 0 ? 0 : obj_tabela?.Pa_Total_MS_Composto.toFixed(3).toString().replace('.', ',')}
                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Pa_Peso_dieta_Composto === 0 ? 0 : obj_tabela?.Pa_Peso_dieta_Composto.toFixed(0).toString().replace('.', ',')}
                          %
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                }}>
                  <div style={{
                    display: 'flex',
                    flex: 0.2,
                    justifyContent: "center",
                    border: `1px solid black`,
                    margin: 1,
                    fontSize: 12,
                    flexDirection: 'column',
                    // fontWeight: "bold",,
                  }}>
                    <div style={{
                      padding: 1,
                      fontSize: 12,
                      fontWeight: "bold",

                    }}>
                      2. Caderno de Campo

                    </div>

                    {
                      sub_tabela.length === 0 ? <></> :
                        sub_tabela.map((el, key) => {

                          return (
                            <div>
                              Grupo Homogéneo {key + 1}
                            </div>
                          )
                        })


                    }




                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1,
                      paddingTop: 10,

                    }}>
                      Total de MS


                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      Peso na dieta (%)


                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    flex: 0.8,
                    alignItems: 'center',
                    flexDirection: 'column',
                    fontSize: 12,

                  }}>

                    <div style={{
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      display: 'flex',
                      flexDirection: 'row',
                      // backgroundColor:'red',
                      width: '100%',
                      height: '100%',
                      margin: 1,

                    }}>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        {
                          sub_tabela.length === 0 ? <></> :
                            sub_tabela.map((el, key) => {

                              return (
                                <div key={key}>
                                  {el?.grupo_homo_Total_MS_Pastagem === 0 ? 0 : el?.grupo_homo_Total_MS_Pastagem.toFixed(3).toString().replace('.', ',')}
                                </div>
                              )
                            })


                        }
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1,
                          paddingTop: 10,

                        }}>

                          {obj_tabela?.CC_Total_MS_Pastagem === 0 ? 0 : obj_tabela?.CC_Total_MS_Pastagem.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.CC_Peso_dieta_Pastagem === 0 ? 0 : obj_tabela?.CC_Peso_dieta_Pastagem.toFixed(0).toString().replace('.', ',')}

                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        {
                          sub_tabela.length === 0 ? <></> :
                            sub_tabela.map((el, key) => {

                              return (
                                <div key={key}>
                                  {el?.grupo_homo_Total_MS_Silagem === 0 ? 0 : el?.grupo_homo_Total_MS_Silagem.toFixed(3).toString().replace('.', ',')}
                                </div>
                              )
                            })


                        }
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1,
                          paddingTop: 10,

                        }}>
                          {obj_tabela?.CC_Total_MS_Silagem === 0 ? 0 : obj_tabela?.CC_Total_MS_Silagem.toFixed(3).toString().replace('.', ',')}


                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.CC_Peso_dieta_Silagem === 0 ? 0 : obj_tabela?.CC_Peso_dieta_Silagem.toFixed(0).toString().replace('.', ',')}
                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        {
                          sub_tabela.length === 0 ? <></> :
                            sub_tabela.map((el, key) => {

                              return (
                                <div key={key}>
                                  {el?.grupo_homo_Total_MS_Outra_Ferragem === 0 ? 0 : el?.grupo_homo_Total_MS_Outra_Ferragem.toFixed(3).toString().replace('.', ',')}
                                </div>
                              )
                            })


                        }
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1,
                          paddingTop: 10

                        }}>
                          {obj_tabela?.CC_Total_MS_Outra_Ferragem === 0 ? 0 : obj_tabela?.CC_Total_MS_Outra_Ferragem.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.CC_Peso_dieta_Outra_Ferragem === 0 ? 0 : obj_tabela?.CC_Peso_dieta_Outra_Ferragem.toFixed(0).toString().replace('.', ',')}


                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        {
                          sub_tabela.length === 0 ? <></> :
                            sub_tabela.map((el, key) => {

                              return (
                                <div key={key}>
                                  {el?.grupo_homo_Total_MS_Composto === 0 ? 0 : el?.grupo_homo_Total_MS_Composto.toFixed(3).toString().replace('.', ',')}
                                </div>
                              )
                            })


                        }
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1,
                          paddingTop: 10,

                        }}>
                          {obj_tabela?.CC_Total_MS_Composto === 0 ? 0 : obj_tabela?.CC_Total_MS_Composto.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.CC_Peso_dieta_Composto === 0 ? 0 : obj_tabela?.CC_Peso_dieta_Composto.toFixed(0).toString().replace('.', ',')}

                          %
                        </div>
                      </div>
                    </div>


                  </div>

                </div>
                <div style={{
                  display: "flex",
                  flex: 1,

                }}>
                  <div style={{
                    display: 'flex',
                    flex: 0.2,
                    justifyContent: "center",
                    border: `1px solid black`,
                    margin: 1,
                    fontSize: 12,
                    flexDirection: 'column',
                    // fontWeight: "bold",,
                  }}>
                    <div style={{
                      padding: 1,
                      fontSize: 12,
                      fontWeight: "bold",

                    }}>
                      3. Diferença (2-1)

                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      Total de MS


                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      Peso na dieta (%)


                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    flex: 0.8,
                    alignItems: 'center',
                    flexDirection: 'column',
                    fontSize: 12,

                  }}>

                    <div style={{
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      display: 'flex',
                      flexDirection: 'row',
                      // backgroundColor:'red',
                      width: '100%',
                      height: '100%',
                      margin: 1,


                    }}>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Diferenca_MS_Pastagem === 0 ? 0 : obj_tabela?.Diferenca_MS_Pastagem.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Diferenca_Peso_Dieta_Pastagem === 0 ? 0 : obj_tabela?.Diferenca_Peso_Dieta_Pastagem.toFixed(0).toString().replace('.', ',')}
                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Diferenca_MS_Silagem === 0 ? 0 : obj_tabela?.Diferenca_MS_Silagem.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Diferenca_Peso_Dieta_Silagem === 0 ? 0 : obj_tabela?.Diferenca_Peso_Dieta_Silagem.toFixed(0).toString().replace('.', ',')}
                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Diferenca_MS_Outra_Ferragem === 0 ? 0 : obj_tabela?.Diferenca_MS_Outra_Ferragem.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Diferenca_Peso_Dieta_Outra_Ferragem === 0 ? 0 : obj_tabela?.Diferenca_Peso_Dieta_Outra_Ferragem.toFixed(0).toString().replace('.', ',')}
                          %
                        </div>
                      </div>
                      <div style={{
                        display: "flex",
                        flex: 0.25,
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        margin: 1,
                        flexDirection: "column",

                        // height: 40,

                        height: '100%',

                        border: `1px solid black`,
                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Diferenca_MS_Composto === 0 ? 0 : obj_tabela?.Diferenca_MS_Composto.toFixed(3).toString().replace('.', ',')}

                        </div>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: "flex-end",
                          padding: 1

                        }}>
                          {obj_tabela?.Diferenca_Peso_Dieta_Composto === 0 ? 0 : obj_tabela?.Diferenca_Peso_Dieta_Composto.toFixed(0).toString().replace('.', ',')}

                          %
                        </div>
                      </div>
                    </div>


                  </div>

                </div>

              </table>
            </TableContainer>
          </CustomThemeProvider>
        )}
      </main>
    </div>
  );
}
